import { render, staticRenderFns } from "./supplierRFQEdit.vue?vue&type=template&id=c88b9f02&scoped=true&"
import script from "./supplierRFQEdit.vue?vue&type=script&lang=js&"
export * from "./supplierRFQEdit.vue?vue&type=script&lang=js&"
import style0 from "./supplierRFQEdit.vue?vue&type=style&index=0&id=c88b9f02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88b9f02",
  null
  
)

component.options.__file = "supplierRFQEdit.vue"
export default component.exports